<template>
  <div class="buttonRow">
    <v-container fluid>
      <v-row>
        <slot name="leftSide"></slot>
        <v-spacer v-if="!noSpacer" />
        <slot />
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "buttonRowComponent",

  props: ["noSpacer"]
};
</script>
